<template>
  <div>
    <v-card class="mx-auto" max-width="1000" elevation="0" style="margin:10px;">
      <v-row>
        <v-col md="3"></v-col>
        <v-col md="6">
          <h3 style="text-align:center;color:black;">
            <b>SignUp</b>
          </h3>
          <v-form ref="form">
            <v-text-field
              id="firstname"
              v-model="firstname"
              prepend-icon="mdi-account"
              label="First Name"
              type="text"
              :rules="nameRules"
              required
            />

            <v-text-field
              id="lastname"
              v-model="lastname"
              prepend-icon="mdi-account"
              label="Last Name"
              type="text"
              :rules="nameRules"
              required
            />
            <v-radio-group class="prfont cr"
                v-model="gender"
               prepend-icon="mdi-gender-male-female"
                label="Gender"
                row
              >
                <v-radio label="Male"  class="prfont cr" value="male"></v-radio>
                <v-radio label="Female"  class="prfont cr" value="female"></v-radio>
              </v-radio-group>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dob"
                  label="Date of Birth"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  required
                  :rules="dobRules"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dob" @input="menu2 = false"></v-date-picker>
            </v-menu>
            <v-text-field
              id="username"
              v-model="username"
              prepend-icon="mdi-account-circle"
              label="Username"
              type="text"
              required
              :rules="userRules"
            />
            <v-text-field
              id="password"
              v-model="password"
              prepend-icon="mdi-lock"
              label="Password"
              type="password"
              required
              :rules="pwdRules"
            />
            <v-text-field
              id="passwordcnf"
              v-model="passwordcnf"
              prepend-icon="mdi-lock"
              label="Confirm Password"
              type="password"
              :rules="pwdConfirm"
              required
            />
            <!-- <p style="color:red">  {{msg4}}</p> -->

            <v-text-field
              id="phone"
              v-model="phone"
              prepend-icon="mdi-phone"
              label="Phone"
              type="text"
              :rules="phoneRules"
              required
            />
            <v-text-field
              id="email"
              v-model="email"
              prepend-icon="mdi-email"
              label="Email"
              type="email"
              :rules="emailRules"
              required
            />

            <v-layout wrap justify-center>
              <v-flex xs12 md12 pt-2 text-center>
                <v-btn
                  rounded
                  :disabled="false"
                  width="500px"
                  class="text-capitalize hh"
                  dark
                  :ripple="false"
                  color="#ff4e00"
                  @click="reginit"
                >SIGNUP</v-btn>
              </v-flex>
            </v-layout>
            <br />

            <!-- <v-card-actions>
                <v-btn color="red" text @click="signindialog = false">Cancel</v-btn>
                <v-spacer />
                <v-btn color="#0e4e35" text @click="reginit">Signup</v-btn>
            </v-card-actions>-->
          </v-form>
        </v-col>
      </v-row>
    </v-card>
    <br />
  </div>
</template>
<script>
import store from "../../store";
import axios from "axios";
import { request } from "http";
export default {
  data() {
    return {
      msg4: "",
      menu: false,
      logindialog: false,
      signindialog: false,
      login: {
        username: "",
        password: ""
      },
      passwordcnf: "",
      firstname: null,
      lastname: null,
      dob: new Date().toISOString().substr(0, 10),
      gender: 'male',
      username: null,
      password: null,
      phone: null,
      email: null,

      pwdRules: [v => !!v || "Password required"],
      pwdConfirm: [
        v => !!v || "Confirm password",
        v => v === this.password || "Passwords do not match"
      ],

      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      nameRules: [v => !!v || "Name is required"],
      genderRules: [v => !!v || " required"],
      dobRules: [v => !!v || " required"],
      userRules: [v => !!v || "required"],
      phoneRules: [v => !!v || "Phone is required"],

      isLogedIn: localStorage.getItem("isLoggedIn"),
      menu2: false,
      msg: null,

      sideNav: false
    };
  },
  watch: {
    password: function() {
      if (this.password === this.passwordcnf) {
        this.msg4 = "Password Correct";
      } else {
        this.msg4 = "Password doesn't match";
      }
    }
  },

  methods: {
    reginit() {
      if (this.$refs.form.validate()) {
        var datas = {};
        datas["firstname"] = this.firstname;
        datas["lastname"] = this.lastname;
        datas["dob"] = this.dob;
        datas["gender"] = this.gender;
        datas["username"] = this.username;
        datas["password"] = this.password;
        datas["email"] = this.email;
        datas["phone"] = this.phone;
        // this.dialog = false;
        axios({
          method: "POST",
          url: "/user/clientregister/",
          data: datas
        })
          .then(response => {
            if (response.data.status == true) {
              this.msg = "successfully registered";
              this.$dlg.alert(
                this.msg,
                () => {
                  this.$router.push("/AppLogin/");
                },
                { messageType: "success" }
              );
            } else {
              this.msg = response.data.msg;
              this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
            }
          })
          .catch(e => {
            this.msg = "Not Success";
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          });
        // .catch(err => {
        //   console.log(err)
        //   var msg=err.response.data.msg;
        //   alert(msg);

        // });
      }
    }
  }
};
</script>
<style scoped>
.hb {
  background-color: #ff4e00;
  background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
}
.hh {
  background-color: #ff4e00;
  
}
</style>